import { render, staticRenderFns } from "./tableTableHeader.vue?vue&type=template&id=66272489&"
import script from "./tableTableHeader.vue?vue&type=script&lang=js&"
export * from "./tableTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./tableTableHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports